import axios from 'axios';
import { baseURL, environment } from '../../../api/environment';

const URL = baseURL;

/**
 * Registra la transacción recibida de Banamex
 * @param {Object} params - Parámetros de la transacción
 * @param {string} params.cliente - Folio del cliente
 * @param {string} params.orderId - ID de la orden
 * @param {string} params.canalPago - Canal de pago (BANAMEX)
 * @param {string} params.currentStatus - Estado actual de la transacción
 * @param {string} params.authCode - Código de autorización
 * @param {string} params.monto - Monto de la transacción
 * @param {string} params.reference - Referencia de pago
 * @param {string} params.productDesc - Descripción del producto
 * @param {string} params.canalOrigen - Canal de origen (WEB)
 * @returns {Promise<Object>} Respuesta del servidor
 */
export const tranRecibidaBanamex = async ({ commit, rootState }, params) => {
    try {
        commit('SET_LOADING', true);
        const env = environment.ENV;
        
        // Endpoint de Banamex según ambiente
        // Nota: El endpoint de Banamex usa 'stage' para dev y 'prod' para producción
        const endpoint = env === 'production'
            ? 'https://481vwlnrk7.execute-api.us-east-1.amazonaws.com/Prod/tranrecibidabanamex'
            : 'https://26licsrt3m.execute-api.us-east-1.amazonaws.com/stage/tranrecibidabanamex';
        
        console.log('🏦 Banamex - Ambiente:', env);
        console.log('🏦 Banamex - Endpoint:', endpoint);
        console.log('📤 Banamex - Datos enviados:', params);
        
        const token = await rootState.Token.token.dataObj;
        
        const { data } = await axios.request({
            url: endpoint,
            method: 'post',
            responseType: 'json',
            headers: {
                'Authorization': token,
                'Content-Type': 'application/json'
            },
            data: {
                orderId: params.orderId,
                cliente: params.cliente,
                monto: params.monto,
                canalPago: params.canalPago,
                currentStatus: params.currentStatus,
                authCode: params.authCode,
                reference: params.reference,
                productDesc: params.productDesc,
                canalOrigen: params.canalOrigen,
                idConcepto: params.idConcepto
            }
        });
        
        commit('SET_Tran_Recibida_Banamex', data);
        console.log('✅ Banamex - Transacción registrada exitosamente');
        console.log('📥 Banamex - Respuesta:', data);
        
        return data;
    } catch (err) {
        console.error('❌ Banamex - Error completo:', err);
        console.error('❌ Banamex - Error response:', err.response?.data);
        console.error('❌ Banamex - Error status:', err.response?.status);
        commit('SET_ERROR_SUBSCRIPTION', err.response?.data?.message || err.message);
        throw err;
    } finally {
        commit('SET_LOADING', false);
    }
};
